import { EXPERTISE_TYPES } from '../briefs/briefCreateForm';

const labelStyle = { color: 'var(--rs-text-secondary)', fontSize: '0.8em', marginBottom: '0.1rem' };
const valueStyle = { fontWeight: 500, marginBottom: '0.5rem' };
const sectionStyle = { marginBottom: '1rem' };

function ContactList({ contacts, title }) {
    if (!contacts || contacts.length === 0) return null;
    return (
        <div style={sectionStyle}>
            <div style={labelStyle}>{title}</div>
            {contacts.map((c, i) => (
                <div key={i} style={{ fontSize: '0.9em', marginBottom: '0.25rem', display: 'flex', gap: '1rem' }}>
                    {c.fio && <span>{c.fio}</span>}
                    {c.email && <span style={{ color: 'var(--rs-text-secondary)' }}>{c.email}</span>}
                    {c.phone && <span style={{ color: 'var(--rs-text-secondary)' }}>{c.phone}</span>}
                </div>
            ))}
        </div>
    );
}

export default function BriefInfoPanel({ meta }) {
    if (!meta) return null;

    const expertiseLabel = EXPERTISE_TYPES.find(t => t.value === meta.expertise_type)?.label || meta.expertise_type;

    return (
        <div style={{
            background: 'var(--rs-gray-50)',
            border: '1px solid var(--rs-border-primary)',
            borderRadius: '0.5rem',
            padding: '1rem 1.25rem',
            marginBottom: '1rem',
        }}>
            {meta.org_name && (
                <div style={sectionStyle}>
                    <div style={labelStyle}>Наименование юр. лица (заказчик)</div>
                    <div style={valueStyle}>{meta.org_name}</div>
                </div>
            )}

            <div style={sectionStyle}>
                <div style={labelStyle}>Вид проекта</div>
                <div style={valueStyle}>{expertiseLabel}</div>
            </div>

            {(meta.contract_number || meta.contract_date) && (
                <div style={sectionStyle}>
                    <div style={labelStyle}>Реквизиты договора</div>
                    <div style={valueStyle}>
                        {[meta.contract_number && `№ ${meta.contract_number}`, meta.contract_date].filter(Boolean).join(' от ')}
                    </div>
                </div>
            )}

            <ContactList contacts={meta.client_contacts} title="Ответственные лица со стороны заказчика" />
            <ContactList contacts={meta.eco_contacts} title="Ответственные лица со стороны разработчиков" />
        </div>
    );
}
